import moment from 'moment';

// Hotel check-in/out policy (authSlice checkintime etc.). All blank = the hotel never set
// them, which keeps the legacy behaviour: arrival is "now" and departure = arrival + days.
export interface StayTimeSettings {
  checkintime?: string;
  checkouttime?: string;
  otacheckintime?: string;
  otacheckouttime?: string;
  default24h?: number;
}


const policy = (s: StayTimeSettings | undefined, isOta: boolean) => ({
  inTime: (isOta ? s?.otacheckintime : s?.checkintime) || '',
  outTime: (isOta ? s?.otacheckouttime : s?.checkouttime) || ''
});

const withTime = (m: moment.Moment, hhmm: string) => {
  const [h, mi] = hhmm.split(':').map(Number);
  return m.clone().set({ hour: h, minute: mi, second: 0, millisecond: 0 });
};

/** True when departure is pinned to a fixed checkout time (not following the arrival time). */
export const usesFixedCheckout = (
  s: StayTimeSettings | undefined,
  isOta: boolean,
  is24: boolean
) => !is24 && !!policy(s, isOta).outTime;

/** Arrival for a new stay: today at the policy check-in time, else now. */
export const defaultArrival = (
  s: StayTimeSettings | undefined,
  isOta: boolean,
  is24: boolean,
  base: moment.Moment = moment()
) => {
  const { inTime } = policy(s, isOta);
  return !is24 && inTime ? withTime(base, inTime) : base.clone();
};

/** Departure = arrival + days, at the policy checkout time unless 24-hour mode (or no policy). */
export const computeDeparture = (
  arrival: moment.Moment,
  days: number,
  s: StayTimeSettings | undefined,
  isOta: boolean,
  is24: boolean
) => {
  const dep = arrival.clone().add(days, 'days');
  return usesFixedCheckout(s, isOta, is24) ? withTime(dep, policy(s, isOta).outTime) : dep;
};

/** Whole days of a stay: calendar-day difference when departure is a fixed checkout time. */
export const stayDays = (
  arrival: moment.Moment,
  departure: moment.Moment,
  s: StayTimeSettings | undefined,
  isOta: boolean,
  is24: boolean
) =>
  usesFixedCheckout(s, isOta, is24)
    ? departure.clone().startOf('day').diff(arrival.clone().startOf('day'), 'days')
    : departure.diff(arrival, 'days');


